export enum FiltersType {
  COMPOSER = "composer",
  TAGS = "tags",
  LENGTH = "length",
  BPM = "bpm",
  IS_ALBUMS_TAB = "isAlbumsTab",
  PAGE_NUMBER = "pageNumber",
  IS_FILTERS_OPEN = "isFiltersOpen",
}
